import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import user from "../../../assets/images/user.png";
import IconAngry from '../../Common/Icon/iconAngry';
import IconDislike from '../../Common/Icon/iconDislike';
import IconLaugh from '../../Common/Icon/iconLaugh';
import IconHeartbreak from '../../Common/Icon/iconHeartbreak';
import IconLike from '../../Common/Icon/iconLike';
import IconLove from '../../Common/Icon/iconLove';
import IconSad from '../../Common/Icon/iconSad';
import iconPath from "./../../../helpers/iconHelper";
import "./FeedFooterLike.css"

function TabPanel(props) {
  const { children, value, index} = props;
 
  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
     
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function rand() {
  return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
  const top = 45;
  const left = 45;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles(theme => ({
  paper: {
    position: 'absolute',
    width: 740,
    backgroundColor: theme.palette.background.paper,
    border: '0',
    boxShadow: theme.shadows[12],
   
  },

  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function LikeModal(props) {

  const classes         = useStyles();
  const [modalStyle]    = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);
  const modalOpen       = props.modalOpen;
  const dataList        = props.reactionList
  const [value, setValue] = React.useState(0);
 
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleOpen = () => {
  
  };

  const handleClose = () => {
     
      props.handleClose();
  };
  const deleteRow = (id,type) => {
    props.deleteRow(id,type);
  }

  return (
    
   <Modal
    aria-labelledby="simple-modal-title"
    aria-describedby="simple-modal-description"
    open={modalOpen}
    onClose={handleClose}
    >
      <div style={modalStyle} className={`popup_list ${classes.paper}`} >
       
              <div className="popup_inner">
                <div className={classes.root}>
                    <AppBar position="static">
                        <Tabs 
                          value={value} 
                          onChange={handleChange} 
                          aria-label="simple tabs example" 
                          variant="scrollable"
                          scrollButtons="on"
                        >
                        <Tab label={dataList.total_like} icon={<IconLike />} disabled={(dataList.total_like == 0) ? true : false} />
                        <Tab label={dataList.total_dislike} icon={<IconDislike />} disabled={(dataList.total_dislike == 0) ? true : false}/>
                        <Tab label={dataList.total_laugh} icon={<IconLaugh />} disabled={(dataList.total_laugh == 0) ? true : false}/>
                        <Tab label={dataList.total_angry} icon={<IconAngry />} disabled={(dataList.total_angry == 0) ? true : false}/>
                        <Tab label={dataList.total_love} icon={<IconLove />} disabled={(dataList.total_love == 0) ? true : false}/>
                        <Tab label={dataList.total_sad} icon={<IconSad />} disabled={(dataList.total_sad == 0) ? true : false}/>
                        <Tab label={dataList.total_breakheart} icon={<IconHeartbreak />} disabled={(dataList.total_breakheart == 0) ? true : false}/>
                        </Tabs>
                    </AppBar>
                    <TabPanel value={value} index={0}>
                    {  (Object.keys(dataList).length > 0) ? 
                         (dataList.like_details).map((reaction,index) => {
                          return (
                            <div className={(reaction.membership == 'GOLD') ? 'relation_user golden_m' : 'relation_user'}  key={`like${index}`}>
                              <div><img src={(reaction.media_link != '') ? reaction.media_link : iconPath['DEFAULTUSER']} /></div>
                              <div className="relation_user_info">
                                  <h4>{reaction.full_name}</h4>
                                  <p>{reaction.country_name}</p>
                              </div>
                            </div>
                            
                          )
                        })
                      : null 
                    }
                      
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                    {  (Object.keys(dataList).length > 0) ? 
                         (dataList.dislike_details).map((reaction,index) => {
                          return (
                            <div className={(reaction.membership == 'GOLD') ? 'relation_user golden_m' : 'relation_user'}  key={`dislike${index}`}>
                              <div><img src={(reaction.media_link != '') ? reaction.media_link : iconPath['DEFAULTUSER']} /></div>
                              <div className="relation_user_info">
                                  <h4>{reaction.full_name}</h4>
                                  <p>{reaction.country_name}</p>
                              </div>
                            </div>
                            
                          )
                        })
                      : null 
                    }
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                    {  (Object.keys(dataList).length > 0) ? 
                         (dataList.laugh_details).map((reaction,index) => {
                          return (
                            <div className={(reaction.membership == 'GOLD') ? 'relation_user golden_m' : 'relation_user'}  key={`laugh${index}`}>
                              <div><img src={(reaction.media_link != '') ? reaction.media_link :  iconPath['DEFAULTUSER']} /></div>
                              <div className="relation_user_info">
                                  <h4>{reaction.full_name}</h4>
                                  <p>{reaction.country_name}</p>
                              </div>
                            </div>
                            
                          )
                        })
                      : null 
                    }
                    </TabPanel>
                    <TabPanel value={value} index={3}>
                    {  (Object.keys(dataList).length > 0) ? 
                         (dataList.angry_details).map((reaction,index) => {
                          return (
                            <div className={(reaction.membership == 'GOLD') ? 'relation_user golden_m' : 'relation_user'}  key={`angry${index}`}>
                              <div><img src={(reaction.media_link != '') ? reaction.media_link :  iconPath['DEFAULTUSER']} /></div>
                              <div className="relation_user_info">
                                  <h4>{reaction.full_name}</h4>
                                  <p>{reaction.country_name}</p>
                              </div>
                            </div>
                            
                          )
                        })
                      : null 
                    }
                    </TabPanel>
                    <TabPanel value={value} index={4}>
                    {  (Object.keys(dataList).length > 0) ? 
                         (dataList.love_details).map((reaction,index) => {
                          return (
                            <div className={(reaction.membership == 'GOLD') ? 'relation_user golden_m' : 'relation_user'}  key={`love${index}`}>
                              <div><img src={(reaction.media_link != '') ? reaction.media_link :  iconPath['DEFAULTUSER']} /></div>
                              <div className="relation_user_info">
                                  <h4>{reaction.full_name}</h4>
                                  <p>{reaction.country_name}</p>
                              </div>
                            </div>
                            
                          )
                        })
                      : null 
                    }
                    </TabPanel>
                    <TabPanel value={value} index={5}>
                    {  (Object.keys(dataList).length > 0) ? 
                         (dataList.sad_details).map((reaction,index) => {
                          return (
                            <div className={(reaction.membership == 'GOLD') ? 'relation_user golden_m' : 'relation_user'}  key={`sad${index}`}>
                              <div><img src={(reaction.media_link != '') ? reaction.media_link :  iconPath['DEFAULTUSER']} /></div>
                              <div className="relation_user_info">
                                  <h4>{reaction.full_name}</h4>
                                  <p>{reaction.country_name}</p>
                              </div>
                            </div>
                            
                          )
                        })
                      : null 
                    }
                    </TabPanel>
                    <TabPanel value={value} index={6}>
                    {  (Object.keys(dataList).length > 0) ? 
                          (dataList.breakheart_details).map((reaction,index) => {
                            return (
                              <div className={(reaction.membership == 'GOLD') ? 'relation_user golden_m' : 'relation_user'}  key={`breakheart${index}`}>
                                <div><img src={(reaction.media_link != '') ? reaction.media_link :  iconPath['DEFAULTUSER']} /></div>
                                <div className="relation_user_info">
                                    <h4>{reaction.full_name}</h4>
                                    <p>{reaction.country_name}</p>
                                </div>
                              </div>
                              
                            )
                          })
                        : null 
                      }
                    </TabPanel>
                </div>
           
           </div>
      </div>
    </Modal>
     
  
  );
}
